import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

import Copyright from "./Copyright";
import { ROUTES } from "core/links";

const AuthFooter = () => {
  return (
    <>
      <footer className="py-1">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="12">
              <Nav className="nav-footer justify-content-center">
                <NavItem className="text-sm text-3572EF">
                  <NavLink href={ROUTES.ABOUT_US}>
                    About Us
                  </NavLink>
                </NavItem>
                <NavItem className="text-sm text-3572EF">
                  <NavLink href={ROUTES.PRIVACY}>
                    Privacy Policy
                  </NavLink>
                </NavItem>
                {/* <NavItem className="text-sm text-3572EF">
                  <NavLink href={ROUTES.TERMS}>
                    Terms & Conditions
                  </NavLink>
                </NavItem> */}
              </Nav>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="12">
              <Copyright align="text-center" />
            </Col>
          </Row>
        </Container>
      </footer >
    </>
  );
};

export default AuthFooter;
